import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSpeaker: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="speaker, music, sound"><path d="M4.75 2.75H19.25V21.25H4.75V2.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M15.5 14.25C15.5 16.183 13.933 17.75 12 17.75C10.067 17.75 8.5 16.183 8.5 14.25C8.5 12.317 10.067 10.75 12 10.75C13.933 10.75 15.5 12.317 15.5 14.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M9.75 6.75H14.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconSpeaker;
